import React from "react";
import { Container, Row } from "react-bootstrap";
import {
    AiFillInstagram,
} from "react-icons/ai";
import { FaXTwitter, FaLinkedinIn, FaYoutube } from "react-icons/fa6";
import { IoPhonePortraitOutline } from "react-icons/io5";
import { CiMail } from "react-icons/ci";

import WhatsAppShareLink from "./WhatsApp";

import Image from 'react-bootstrap/Image';
import logoWhite from "../Assets/logo-white.png"
import iso9001 from "../Assets/ISO9001-2015.png"

function Footer() {
    let date = new Date();
    let year = date.getFullYear();
    return (
        <div>
            <section className='px-5 pb-5'>
                <div className='p-5 rounded-top-24 bg-white text-center'>
                    <h1 className='pb-5 heading-style'>Extra hand, Exact fit</h1>
                    <h4 className="text-size-large">Right Talent. Right Time. Zero Compromise.</h4>
                </div>
                <div className="d-md-flex justify-content-around bg-black p-5 rounded-bottom-24">
                    <div className="text-white">
                        <h3><IoPhonePortraitOutline /> +91 9347113488</h3>
                    </div>
                    <div className="text-white">
                        <h3><CiMail /> info@cewaves.com</h3>
                    </div>
                </div>
            </section >
            <Container fluid className="footer">
                <Row className="px-md-5">
                    <div className="col-md-5">
                        <div className="p-3 mb-2 text-white text-center">
                            <Image src={logoWhite} className="w-25" />
                            <ul className="footer-icons">
                                <li className="social-icons">
                                    <a
                                        href="https://youtube.com/@cewaves?si=gacVobG1b9G74ewP"
                                        style={{ color: "white" }}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <FaYoutube />
                                    </a>
                                </li>
                                <li className="social-icons">
                                    <a
                                        href="https://x.com/CeWaves60316"
                                        style={{ color: "white" }}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <FaXTwitter />
                                    </a>
                                </li>
                                <li className="social-icons">
                                    <a
                                        href="https://www.linkedin.com/company/cewaves-technologies/?viewAsMember=true"
                                        style={{ color: "white" }}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <FaLinkedinIn />
                                    </a>
                                </li>
                                <li className="social-icons">
                                    <a
                                        href="https://www.instagram.com/cewaves_technologies/"
                                        style={{ color: "white" }}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <AiFillInstagram />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <Image src={iso9001} className="w-25 pt-5" />
                    </div>
                    <div className="col-md-4 p-5 border-md-start border-secondary d-flex flex-column justify-content-between">
                        <ul className="list-unstyled">
                            <li className="pb-2">
                                <a className="text-white text-decoration-none" href="/about">About</a>
                            </li>
                            <li className="pb-2">
                                <a className="text-white text-decoration-none" href="/services">Services</a>
                            </li>
                            <li className="pb-2">
                                <a className="text-white text-decoration-none" href="/contact">Contact</a>
                            </li>
                        </ul>
                        <h3>Copyright © {year} CeWaves</h3>
                    </div>

                </Row>
                <WhatsAppShareLink />
            </Container>
        </div>

    );
}

export default Footer;